export default __webpack_public_path__ + "static/media/list.61013555.svg";